import { useEffect, useState } from 'react';
import { usePlatformBranding } from '@/hooks/use-platform-branding';
import styles from './BrandIdentity.module.scss';

interface BrandIdentityProps {
  compact?: boolean;
  className?: string;
}

export function BrandIdentity({ compact = false, className = '' }: BrandIdentityProps) {
  const { branding } = usePlatformBranding();
  const [lightFailed, setLightFailed] = useState(false);
  const [darkFailed, setDarkFailed] = useState(false);

  useEffect(() => setLightFailed(false), [branding.logo_light_url]);
  useEffect(() => setDarkFailed(false), [branding.logo_dark_url]);

  const hasLight = Boolean(branding.logo_light_url) && !lightFailed;
  const hasDark = Boolean(branding.logo_dark_url) && !darkFailed;
  const rootClass = [
    styles.root,
    compact ? styles.compact : '',
    hasLight ? styles.hasLight : '',
    hasDark ? styles.hasDark : '',
    className,
  ].filter(Boolean).join(' ');
  const initial = Array.from(branding.app_name.trim())[0]?.toUpperCase() ?? 'Z';

  return (
    <span className={rootClass} aria-label={branding.app_name}>
      <span className={styles.visual} aria-hidden="true">
        <span className={styles.fallback}>{initial}</span>
        {hasLight && (
          <img
            className={`${styles.logo} ${styles.logoLight}`}
            src={branding.logo_light_url ?? undefined}
            alt=""
            onError={() => setLightFailed(true)}
          />
        )}
        {hasDark && (
          <img
            className={`${styles.logo} ${styles.logoDark}`}
            src={branding.logo_dark_url ?? undefined}
            alt=""
            onError={() => setDarkFailed(true)}
          />
        )}
      </span>
      {!compact && <span className={styles.name}>{branding.app_name}</span>}
    </span>
  );
}
